import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/sonner";

// Pages
import MarketingLayout from "./MarketingLayout";
import TopPage from "./TopPage";

import TradeLawPage from "./trade-law";
import TermsPage from "./terms";
import PrivacyPage from "./privacy";
import FeaturesPage from "./features";
import PricingPage from "./pricing";
// Blog pages
import BlogIndexPage from "./blog/index";
import KobutsushoGuidePage from "./blog/kobutsusho-guide";
import HowToStartPage from "./blog/how-to-start";
import OripaSiteComparisonPage from "./blog/oripa-site-comparison";
import HowToCreateOripaSitePage from "./blog/how-to-create-oripa-site";
import OripaRegulationGuidePage from "./blog/oripa-regulation-guide";
import OripaLegalGuidePage from "./blog/oripa-legal-guide";
import OripaMarketTrends2026Page from "./blog/oripa-market-trends-2026";
import OripaSourcingGuidePage from "./blog/oripa-sourcing-guide";
import HowToStartOripaBusinessPage from "./blog/how-to-start-oripa-business";
import HowToCreateKujiPage from "./blog/how-to-create-kuji";

// News pages
import NewsPage from "./NewsPage";
import NewsDetailPage from "./NewsDetailPage";

// Support pages
import FaqPage from "./FaqPage";
import ContactPage from "./ContactPage";

const JoybaseJpApp: React.FC = () => {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* TOP - マーケティングページ */}
          <Route path="/" element={<MarketingLayout><TopPage /></MarketingLayout>} />

          {/* KUJI LP は提供検討のため公開停止中 */}
          <Route path="/kuji/*" element={<Navigate to="/" replace />} />

          {/* Marketing pages */}
          <Route path="/for_shops" element={<MarketingLayout><TopPage /></MarketingLayout>} />
          <Route path="/for_shops/terms" element={<MarketingLayout><TermsPage /></MarketingLayout>} />
          <Route path="/for_shops/privacy" element={<MarketingLayout><PrivacyPage /></MarketingLayout>} />
          <Route path="/for_shops/trade-law" element={<MarketingLayout><TradeLawPage /></MarketingLayout>} />
          <Route path="/for_shops/how-to-start" element={<Navigate to="/blog/how-to-start" replace />} />
          <Route path="/terms" element={<MarketingLayout><TermsPage /></MarketingLayout>} />
          <Route path="/privacy" element={<MarketingLayout><PrivacyPage /></MarketingLayout>} />
          <Route path="/trade-law" element={<MarketingLayout><TradeLawPage /></MarketingLayout>} />
          <Route path="/how-to-start" element={<Navigate to="/blog/how-to-start" replace />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          {/* Blog pages */}
          <Route path="/blog" element={<BlogIndexPage />} />
          <Route path="/blog/kobutsusho-guide" element={<KobutsushoGuidePage />} />
          <Route path="/blog/how-to-start" element={<HowToStartPage />} />
          <Route path="/blog/oripa-site-comparison" element={<OripaSiteComparisonPage />} />
          <Route path="/blog/how-to-create-oripa-site" element={<HowToCreateOripaSitePage />} />
          <Route path="/blog/oripa-regulation-guide" element={<OripaRegulationGuidePage />} />
          <Route path="/blog/oripa-legal-guide" element={<OripaLegalGuidePage />} />
          <Route path="/blog/oripa-market-trends-2026" element={<OripaMarketTrends2026Page />} />
          <Route path="/blog/oripa-sourcing-guide" element={<OripaSourcingGuidePage />} />
          <Route path="/blog/how-to-start-oripa-business" element={<HowToStartOripaBusinessPage />} />
          <Route path="/blog/how-to-create-kuji" element={<HowToCreateKujiPage />} />

          {/* News pages */}
          <Route path="/news" element={<NewsPage />} />
          <Route path="/news/:slug" element={<NewsDetailPage />} />

          {/* Support pages */}
          <Route path="/faq" element={<FaqPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        <Toaster position="top-center" />
      </Router>
    </HelmetProvider>
  );
};

export default JoybaseJpApp;
